import type { Requirement } from "@investhinks/api-client";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import StructureRequirementsCard from "../RequirementsCard";
import AmbassadorInfoModal from "./AmbassadorInfoModal";

interface AmbassadorRequirementsCardProps {
  requirements?: Requirement[];
  onSubmit?: () => void;
  isLoading: boolean;
  compact?: boolean;
}

const AmbassadorRequirementsCard: React.FC<AmbassadorRequirementsCardProps> = ({
  requirements = [],
  onSubmit,
  isLoading,
  compact = false,
}) => {
  const { t } = useTranslation("referrer", { keyPrefix: "partner.ambassadorRequirementsCard" });
  const { t: tRequirements } = useTranslation("referrer", { keyPrefix: "requirementsCard" });
  const [isOpenPublicity, setIsOpenPublicity] = useState(false);

  // Get names of requirements that are not met
  const unmetRequirements = useMemo(() => requirements.filter((r) => !r.met).map((r) => r.name), [requirements]);

  const parsedRequirements = [
    [
      {
        code: "CLAIM_ALL_REWARDS_IN_FIRST_YEAR",
        text: tRequirements("CLAIM_ALL_REWARDS_IN_FIRST_YEAR"),
        checked: unmetRequirements.includes("CLAIM_ALL_REWARDS_IN_FIRST_YEAR"),
      },
      {
        code: "HAVE_BOT_WITH_MIN_BALANCE",
        text: tRequirements("HAVE_BOT_WITH_MIN_BALANCE", { minBalance: 10000 }),
        checked: unmetRequirements.includes("HAVE_BOT_WITH_MIN_BALANCE"),
      },
    ],
    [
      {
        code: "BRING_REFERRALS_IN_PERIOD",
        text: tRequirements("BRING_REFERRALS_IN_PERIOD", { numReferrals: 5, numMonths: 2 }),
        checked: unmetRequirements.includes("BRING_REFERRALS_IN_PERIOD"),
      },
      {
        code: "HAVE_BOT_WITH_MIN_BALANCE",
        text: tRequirements("HAVE_BOT_WITH_MIN_BALANCE", { minBalance: 10000 }),
        checked: unmetRequirements.includes("HAVE_BOT_WITH_MIN_BALANCE"),
      },
    ],
  ];

  return (
    <>
      <AmbassadorInfoModal isOpen={isOpenPublicity} close={() => setIsOpenPublicity(false)} />

      <StructureRequirementsCard
        requirements={parsedRequirements}
        title={t("title")}
        actionTitle={t("actionTitle")}
        onInfo={() => setIsOpenPublicity(true)}
        onAction={onSubmit}
        isLoading={isLoading}
        compact={compact}
      />
    </>
  );
};

export default AmbassadorRequirementsCard;
